{
  "My learning": "Mitt lärande",
  "Learnings": "Läranden",
  "Learning": "Titel",
  "Events": "Events",
  "Filter": "Filter",
  "To do": "Att påbörja",
  "Assigned": "Tilldelade",
  "Ongoing": "Pågående",
  "Saved by me": "Sparat",
  "Completed": "Avslutade",
  "No learnings here yet": "Tillfälligt tom",
  "Save to my learning": "Spara till mitt lärande",
  "course-completion-delay-info": "Det kan dröja upp till 72 timmar innan dina framsteg uppdateras.",
  "View Campus Online Data": "Visa din Campus Online-data",
  "View all": "Visa alla",
  "On track": "I fas",
  "My Role": "Min Roll",
  "My Role_plural": "Mina Roller",
  "Type": "Typ",
  "Source": "Partner",
  "Total Time": "Tid",
  "Add other learning time": "Registrera lärtid",
  "Update other learning": "Uppdatera lärtid",
  "completed-singular": "Avslutad"
}
